export const SET_MODAL_STATE = 'SET_MODAL_STATE'
